import { api } from '@/f1/service';
import codes from '@/f1/codes';
import reg from '@/f1/reg';
import { saveAs } from 'file-saver';
import moment from 'moment-timezone'
import { VclFacebook } from 'vue-content-loading';
import htmlViewer from '../Detect.Viewer.i18n';

const _i18n_data = {
  saved: {
    EN : `saved`,
    KO : `저장되었습니다`,
  },
  updated: {
    EN : `updated`,
    KO : `업데이트되었습니다`,
  },
  removed: {
    EN : `removed`,
    KO : `삭제되었습니다`,
  },
};

export default {
  components : { VclFacebook, htmlViewer },
  data : () => {
    return {
      row_id : -1,
      row_position : -1,
      move_function : undefined,
      reg,
      loading : false,
      codes : codes,
      thumbnail_size: '100%',
      confirm: false,
      add: false,
      model : {},
      url_tree : {},
      thumbnail : '',
      row_count : 0,
    }
  },
  computed: {
    i18n_data() { return _i18n_data; },
    depth() { return this.model.depth+1; },
    image() { return this.model.thumbnail && 'data:image/png;base64,' + this.model.thumbnail || ''; }
  },
  methods: {
    clear() {
      this.move_function ? clearInterval(this.move_function) : ''; this.move_function = undefined
      console.log('clear therad detail')
    },
    heilith() {
      try {
        if(this.row_id < 0) { return alert("no have matched, check first the page is dynamic") }
        let target = document.getElementById('target_'+this.row_id + 1)
        let panel = document.getElementById('scroll_panel')

        this.row_position = this.row_position < 0 ? panel.scrollTop + target.offsetTop : this.row_position
        // console.log('gap', gap, 'panel.scrollTop', panel.scrollTop, 'this.row_position', this.row_position)

        let move = function(row_position = this.row_position, func = this.clear()) {
          // console.log('move', panel.scrollTop, row_position)
          if (panel.scrollTop < row_position + 50 && panel.scrollTop > row_position - 300) { func() }
          else { panel.scrollTop += 100 }
        }
        panel.scrollTop = 0
        this.move_function = setInterval(() => move(this.row_position, this.clear), 5);
        setTimeout(() => { clearInterval(this.move_function); this.move_function = undefined }, 5 * 1000) // force clear after 5 sec
      } catch (e) { console.log(e) }
    },
    change(content) {
      window.hey = document.fromTextArea(document.getElementById('abcd'), {
        lineNumbers: true,
          mode:"htmlmixed",
          lineWrapping:true
      });
      console.log("changed")
      this.model = Object.assign({}, this.model, { content : content })
    },
    // selecting() { try { this.heilith() } catch (e) { console.log(e) } },
    copy(x, type) {
      try {
        var tempElem = document.createElement('textarea');
        tempElem.value = x;
        document.body.appendChild(tempElem);
        tempElem.select();
        document.execCommand("copy");
        document.body.removeChild(tempElem);
        this.$toastr.i(`${type} copied`)
      } catch (e) { console.log(e); this.$toastr.i("copied failed") }
    },
    save_rs() {
      let data = (this.model.data.split('\n') || [])
      if(!data.length) { this.$toastr.i('No Site Detected'); return; }
      let blob = new Blob(data, {type: "text/plain;charset=utf-8"});
      let ts = moment(this.model.detected_at).format("YYYY-MM-DD")
      saveAs(blob, `${this.model.domain}_${ts}_detect.log`);
    },
    toggle_thumbnail() { this.thumbnail_size = this.thumbnail_size == '100%' ? '200%' : '100%'; },
    list() { this.$router.push({ name: 'wmds_detect'}); },
    async remove() {
      try {
        let rs = await api.wmds.WMDS_Call('detect', 'delete', { id : this.model.id })
        if(rs.error) { return this.$toastr.e('delete failed') }
        this.$toastr.s(this.i18n_data['removed'][this.i18n]);
        this.$parent.$emit('refresh');
        this.list();
      } catch(e) { this.$toastr.e(e.data ? e.data.message : e.statusText) , this.list() }
    },
    async get({ id } = this.$route.params) {
      console.log('detect.detail.vue', 'load item', id);

      if(id === 'add') { this.add = true; this.lock = false; return; }
      else { this.add = false; }
      try{
        this.loading = true
        let rs = await api.wmds.WMDS_Call('detect', 'detail', { id : id })
        if(rs.error) { return this.$toastr.e("load failed") }

        this.model = Object.assign({ group: {} }, this.model, rs.body, JSON.parse(rs.body.detail_data))
        this.model.url_tree.reverse()
        this.$parent.$emit('loading', false)
        this.loading = false

      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message : e.statusText) , this.list() }
    }
  },
  watch: { '$route' (to, from) { this.get(to.params); }, },
  created: function() {   console.log('detect.detail.vue', 'created'); },
  destroyed: function() { console.log('detect.detail.vue', 'destroyed'); },
  mounted: function() { console.log('detect.detail.vue', 'mounted'); this.get(this.$route.params); },
}
